"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataCy = exports.CheckboxGroup = void 0;
var _CheckboxGroupContext = _interopRequireDefault(require("./CheckboxGroupContext"));
var _CheckboxGroupError = require("./CheckboxGroupError");
var _CheckboxGroupFormLabel = require("./CheckboxGroupFormLabel");
var _CheckboxGroupOption = require("./CheckboxGroupOption");
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["value", "children", "options", "gutter", "loading", "onChange", "title", "vertical", "error"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    loaderContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '8px'
    }
  };
});
var EMPTY_ARRAY = [];
var dataCy = exports.dataCy = 'CheckboxGroup';
var CheckboxGroup = exports.CheckboxGroup = function CheckboxGroup(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? EMPTY_ARRAY : _ref$value,
    children = _ref.children,
    options = _ref.options,
    gutter = _ref.gutter,
    loading = _ref.loading,
    onChange = _ref.onChange,
    title = _ref.title,
    vertical = _ref.vertical,
    error = _ref.error,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles();
  var parentContext = (0, _react.useContext)(_CheckboxGroupContext["default"]);
  var renderCheckbox = function renderCheckbox(option, index) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxGroupOption.CheckboxGroupOption, {
      label: option.name,
      value: option.id,
      dataCy: (0, _lodash.camelCase)(option.name)
    }, index);
  };
  var handleChange = (0, _react.useCallback)(function (event, v) {
    if (event.target.checked) {
      onChange(event, Array.from(new Set([].concat(_toConsumableArray(value), _toConsumableArray(v)))));
    } else {
      onChange(event, _lodash.without.apply(void 0, [value].concat(_toConsumableArray(v))));
    }
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
    component: 'fieldset',
    "data-cy": dataCy,
    children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxGroupFormLabel.CheckboxGroupFormLabel, {
      children: title
    }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormGroup, _objectSpread(_objectSpread({
      row: !vertical
    }, props), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxGroupContext["default"].Provider, {
        value: _objectSpread(_objectSpread({}, parentContext), {}, {
          value: value,
          onChange: handleChange
        }),
        children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: classes.loaderContainer,
          "data-cy-role": 'checkBoxGroupLoader',
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
            size: 24,
            thickness: 5,
            "data-cy-role": 'circleProgress'
          })
        }) : options ? options.map(renderCheckbox) : children
      })
    })), error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckboxGroupError.CheckboxGroupError, {
      children: error
    }) : null]
  });
};
CheckboxGroup.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See CSS API below for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * 	Display group of elements in a compact row.
   */

  row: _propTypes["default"].bool,
  value: _propTypes["default"].arrayOf(_propTypes["default"].number),
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].array, _propTypes["default"].func]),
  options: _propTypes["default"].array,
  title: _propTypes["default"].string,
  gutter: _propTypes["default"].number,
  loading: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};